import React from "react";
import { EditOutlined } from "@mui/icons-material";
import {
  Button, Box, Divider,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAppMeta } from "hooks";
import { useGetLeadDetailQuery } from "store/services/vendorLeadApi";
import VendorLeadBasicDetail from "./vendorLeadComponents/VendorLeadBasicDetail";
import VendorLeadDetailTab from "./vendorLeadComponents/VendorLeadDetailTab";
import {
  useVendorLeadDetailContext,
  VendorLeadDetailContext,
} from "contexts/VendorLeadContext";
import VendorLeadStepper from "./vendorLeadComponents/VendorLeadStepper";
import RequoteButtons from "./vendorLeadComponents/RequoteButtons";

const VendorLeadDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "Leads", path: "/app/crm/vendor-lead/list" },
    { title: "Lead Detail" },
  ];

  const {
    data: vendorLeadDetail,
    isLoading: loadingVendorLeadDetail,
    error,
  } = useGetLeadDetailQuery(id);

  useAppMeta("Lead Detail");

  return (
    <VendorLeadDetailContext.Provider
      value={{ vendorLeadDetail, loadingVendorLeadDetail }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingVendorLeadDetail}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        {!!vendorLeadDetail && (
          <Box paddingX={3} paddingTop={3}>
            <VendorLeadStepper />
          </Box>
        )}

        <BreadcrumbLayout.Paper>
          <VendorLeadBasicDetail />
          <Divider />
          <VendorLeadDetailTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </VendorLeadDetailContext.Provider>
  );
};

export default VendorLeadDetailScreen;

const PageActions = () => {
  const { vendorLeadDetail } = useVendorLeadDetailContext();
  const isEditDisabled = ["Won", "Lost"].includes(vendorLeadDetail?.status);

  return (
    <Box display="flex" gap={1} alignItems="center">
      <RequoteButtons />
      <Link
        to={`/app/crm/vendor-lead/${vendorLeadDetail?._id}/edit`}
        style={{ pointerEvents: isEditDisabled ? "none" : "auto" }}
      >
        <Button
          startIcon={<EditOutlined />}
          variant="contained"
          disabled={isEditDisabled}
        >
          Edit
        </Button>
      </Link>
    </Box >
  );
};